// extracted by mini-css-extract-plugin
export var closeButton = "_he-1";
export var closeX = "_he-3";
export var container = "_he-0";
export var image = "_he-2";